import { getAutomationPageListApi } from '../api/automation';
import {
  paginatedAutomationActions,
  paginatedAutomationSelector,
} from '../redux/slicers/admin/paginatedAutomation';
import { useThumbnailCardDataList } from './useDataList';

export const useAutomation = ({
  requestParams,
  filterByKey,
  defaultBrands,
  defaultSort,
  useGlobalSearch,
  defaultCreatedBy,
  modelType,
} = {}) => {
  const data = useThumbnailCardDataList({
    selector: paginatedAutomationSelector,
    resetAction: paginatedAutomationActions.resetList,
    getAction: getAutomationPageListApi,
    requestParams,
    filterByKey,
    defaultSort,
    useGlobalFilter: true,
    defaultBrands,
    useGlobalSearch,
    defaultCreatedBy,
    modelType,
  });

  return data;
};
